import { Tabs, TabsContent, TabsList, TabsTrigger } from '@civilgrid/ui/components';
import type { ExportEscalation } from '~/api/internal';
import { EXPORT_ESCALATION_REASON_CONFIG } from './constants';
import EscalationsTable from './EscalationsTable';

export type ExportEscalationsProps = {
  tab: ExportEscalation['escalationReason'];
  onTabChange: (tab: ExportEscalation['escalationReason']) => void;
};

export default function ExportEscalations({ tab, onTabChange }: ExportEscalationsProps) {
  return (
    <Tabs
      value={tab}
      onValueChange={(value) => onTabChange(value as ExportEscalation['escalationReason'])}
      className="flex h-full flex-col gap-3"
    >
      <TabsList>
        <TabsTrigger value="restricted" data-testid="export-escalations-tab-restricted">
          {EXPORT_ESCALATION_REASON_CONFIG.restricted.tabLabel}
        </TabsTrigger>
        <TabsTrigger value="failed" data-testid="export-escalations-tab-failed">
          {EXPORT_ESCALATION_REASON_CONFIG.failed.tabLabel}
        </TabsTrigger>
      </TabsList>
      <TabsContent value="restricted" className="min-h-0 flex-1">
        <EscalationsTable reason="restricted" />
      </TabsContent>
      <TabsContent value="failed" className="min-h-0 flex-1">
        <EscalationsTable reason="failed" />
      </TabsContent>
    </Tabs>
  );
}
